import { connect, MapDispatchToProps } from 'react-redux';
import { showFavouritedByModal } from '../../Modals/redux/actionCreators';
import { Props } from './FaveStat';

export type DispatchProps = Pick<Props, 'showFavouritedByModal'>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  showFavouritedByModal,
};

export default connect(null, mapDispatchToProps);
